import { useEffect } from "react";
import { Link } from "react-router-dom";

// Stile contenuto: max-width 800px, tipografia leggibile, palette del sito.
// Titoli usano la stessa famiglia serif del sito (Cormorant Garamond).
export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
    const previous = document.title;
    document.title = "Privacy Policy — Estetica Elite";
    return () => {
      document.title = previous;
    };
  }, []);

  return (
    <article className="ee-policy-page">
      <div className="ee-policy-container">
        <h1>Privacy Policy</h1>
        <p className="ee-policy-meta">
          <strong>Ultimo aggiornamento:</strong> 3 novembre 2026
        </p>

        <p>
          La presente Privacy Policy descrive le modalità di trattamento dei
          dati personali degli utenti che visitano il sito web
          esteticaelite.eu (di seguito, il "Sito") in conformità al Regolamento
          UE 2016/679 (GDPR) e alla normativa italiana vigente in materia di
          protezione dei dati personali.
        </p>

        <h2>1. Titolare del Trattamento dei Dati</h2>
        <p>ELITE S.n.c. di Fanton Paola e Fontolan Erika</p>
        <ul>
          <li>Sede legale: Via Don Federico Tosatto 22, 30174 Venezia (Mestre), Italia</li>
          <li>Partita IVA / Codice Fiscale: 04277830271</li>
          <li>
            Email di contatto:{" "}
            <a href="mailto:info@esteticaelite.eu">info@esteticaelite.eu</a>
          </li>
          <li>
            Telefono: <a href="tel:+39041989574">041 989574</a>
          </li>
        </ul>

        <h2>2. Tipi di Dati raccolti</h2>
        <p>
          Il Sito raccoglie direttamente dati personali solo attraverso il
          modulo di prenotazione, descritto nella sezione 3. Non ci sono moduli
          di contatto, newsletter o registrazioni utente.
        </p>
        <p>
          Inoltre, durante la normale operatività del Sito, vengono raccolti
          automaticamente alcuni dati tramite servizi di terze parti:
        </p>
        <ul>
          <li>
            Dati di utilizzo: indirizzo IP, tipo di browser, sistema operativo,
            pagine visitate, data e ora della visita, durata della permanenza
          </li>
          <li>
            Strumenti di tracciamento: cookie tecnici e di terze parti, come
            dettagliato nella <Link to="/cookie-policy">Cookie Policy</Link>
          </li>
        </ul>
        <p>L'utente può interagire volontariamente con il Sito attraverso:</p>
        <ul>
          <li>Il pulsante "Chiama ora" (avvia una chiamata al numero 041 989574)</li>
          <li>
            Il pulsante "Prenota online" (apre il modulo di prenotazione del
            Sito, descritto nella sezione 3)
          </li>
          <li>I link ai canali social (Facebook)</li>
        </ul>
        <p>
          Eventuali dati personali condivisi durante la chiamata o sui social
          network sono soggetti alle rispettive privacy policy di tali servizi.
        </p>

        <h2>3. Prenotazioni Online</h2>
        <p>
          Con il modulo di prenotazione l'utente sceglie il trattamento, il
          giorno e l'orario, e lascia i propri dati per fissare
          l'appuntamento.
        </p>

        <h3>Quali dati</h3>
        <p>Il modulo chiede:</p>
        <ul>
          <li>Nome e cognome</li>
          <li>Numero di telefono</li>
          <li>Indirizzo email, facoltativo</li>
          <li>
            Note, facoltative: per esempio allergie, preferenze o richieste
            particolari
          </li>
        </ul>
        <p>
          Insieme a questi dati vengono registrati il trattamento, il giorno,
          l'orario e l'operatrice dell'appuntamento. Resta registrato anche
          come è andato l'appuntamento (svolto, annullato oppure mancato) e,
          se è stato usato, il pacchetto o il credito prepagato.
        </p>
        <p>
          Per inviare la prenotazione l'utente deve spuntare la casella "Ho
          letto l'informativa privacy e acconsento al trattamento dei miei
          dati per gestire la prenotazione.": senza la spunta la prenotazione
          non parte. La spunta viene registrata insieme alla prenotazione, con
          la data e l'ora.
        </p>

        <h3>Perché</h3>
        <p>I dati della prenotazione servono per:</p>
        <ul>
          <li>Fissare l'appuntamento e tenere l'orario riservato all'utente</li>
          <li>
            Mandare per email, solo a chi ha lasciato l'indirizzo, la conferma
            della prenotazione, un promemoria il giorno prima e, se
            l'appuntamento è mancato, un avviso
          </li>
          <li>
            Contattare l'utente per telefono o su WhatsApp a proposito
            dell'appuntamento
          </li>
          <li>
            Riconoscere dal numero di telefono un pacchetto o un credito
            prepagato dell'utente, per poterlo usare nella prenotazione
          </li>
          <li>
            Permettere al personale del salone di vedere gli appuntamenti
            passati e futuri dell'utente
          </li>
        </ul>

        <h3>A chi vengono comunicati</h3>
        <p>
          Le prenotazioni le vede il personale del salone, dal pannello di
          gestione protetto da password. Per ogni prenotazione fatta dal Sito
          il salone riceve anche un'email con i dati inseriti nel modulo.
        </p>
        <p>
          I dati passano anche da questi servizi, che fanno funzionare le
          prenotazioni:
        </p>
        <ul>
          <li>Supabase: il database in cui sono conservate le prenotazioni</li>
          <li>
            Vercel Inc.: i server che ricevono il modulo e gestiscono le
            prenotazioni
          </li>
          <li>
            Resend: il servizio che spedisce le email di conferma, di
            promemoria e di avviso, e quella al salone
          </li>
        </ul>
        <p>
          Se il personale scrive all'utente su WhatsApp, il messaggio passa dal
          servizio WhatsApp ed è soggetto anche alla sua privacy policy.
        </p>

        <h3>Dove sono conservati</h3>
        <p>
          Le prenotazioni sono conservate nel database di Supabase, su server
          in Irlanda (Unione Europea). Anche i server di Vercel che ricevono il
          modulo e gestiscono le prenotazioni si trovano in Irlanda.
        </p>

        <h3>Come chiedere la cancellazione</h3>
        <p>
          Per chiedere la cancellazione dei propri dati l'utente può scrivere
          a <a href="mailto:info@esteticaelite.eu">info@esteticaelite.eu</a>{" "}
          oppure chiamare lo <a href="tel:+39041989574">041 989574</a>.
        </p>
        <p>
          Il salone esegue la cancellazione dal pannello di gestione: dagli
          appuntamenti dell'utente, dai pacchetti, dal credito prepagato e
          dalla rubrica dei clienti vengono tolti nome, telefono ed email, e
          dagli appuntamenti anche le note. Gli appuntamenti non si cancellano:
          restano trattamento, giorno e orario, senza più nome, telefono ed
          email di chi li aveva prenotati.
        </p>
        <p>
          Per gli altri diritti, come l'accesso ai propri dati o la loro
          correzione, vale la sezione 8.
        </p>

        <h2>4. Modalità e Luogo del Trattamento</h2>
        <p>
          I dati raccolti tramite il Sito sono trattati con strumenti
          automatizzati nel rispetto dei principi di liceità, correttezza,
          trasparenza, minimizzazione e sicurezza previsti dal GDPR.
        </p>
        <p>
          Il Sito è ospitato sui server di Vercel Inc., con data center in vari
          paesi dell'Unione Europea e Stati Uniti. L'eventuale trasferimento di
          dati al di fuori dell'UE avviene nel rispetto delle Clausole
          Contrattuali Standard approvate dalla Commissione Europea.
        </p>

        <h2>5. Tempi di Conservazione</h2>
        <p>
          I dati di utilizzo raccolti automaticamente dal sistema di hosting
          sono conservati per il tempo strettamente necessario alle finalità di
          sicurezza e diagnostica tecnica, e comunque non oltre 12 mesi.
        </p>
        <p>
          I cookie sono conservati per la durata indicata nella{" "}
          <Link to="/cookie-policy">Cookie Policy</Link>.
        </p>

        <h2>6. Finalità del Trattamento</h2>
        <p>I dati raccolti tramite il Sito sono utilizzati esclusivamente per:</p>
        <ul>
          <li>
            Garantire il corretto funzionamento del Sito e la sua sicurezza
            informatica
          </li>
          <li>
            Permettere agli utenti di visualizzare la posizione del centro
            estetico tramite la mappa interattiva
          </li>
          <li>
            Consentire il caricamento ottimale dei contenuti del Sito (font
            tipografici, immagini)
          </li>
          <li>
            Gestire le prenotazioni fatte con il modulo di prenotazione, come
            descritto nella sezione 3
          </li>
        </ul>
        <p>
          Il Titolare non utilizza i dati personali per finalità di
          profilazione, marketing diretto o pubblicità comportamentale.
        </p>

        <h2>7. Servizi di Terze Parti</h2>

        <h3>Google Maps Widget</h3>
        <ul>
          <li>Fornitore: Google Ireland Limited</li>
          <li>
            Finalità: visualizzazione della mappa interattiva nella sezione
            "Dove siamo"
          </li>
          <li>Dati raccolti: dati di utilizzo, indirizzo IP, cookie</li>
          <li>Luogo del trattamento: Stati Uniti, Irlanda</li>
          <li>
            Privacy Policy:{" "}
            <a
              href="https://policies.google.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
            >
              policies.google.com/privacy
            </a>
          </li>
          <li>Base giuridica: consenso dell'utente (Art. 6, par. 1, lett. a GDPR)</li>
        </ul>

        <h3>Google Fonts</h3>
        <ul>
          <li>Fornitore: Google Ireland Limited</li>
          <li>Finalità: caricamento dei tipi di carattere utilizzati nel Sito</li>
          <li>Dati raccolti: indirizzo IP</li>
          <li>Luogo del trattamento: Stati Uniti, Irlanda</li>
          <li>
            Privacy Policy:{" "}
            <a
              href="https://policies.google.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
            >
              policies.google.com/privacy
            </a>
          </li>
          <li>
            Base giuridica: legittimo interesse del Titolare (Art. 6, par. 1,
            lett. f GDPR)
          </li>
        </ul>

        <h3>Vercel (Hosting)</h3>
        <ul>
          <li>Fornitore: Vercel Inc.</li>
          <li>Finalità: hosting e infrastruttura backend del Sito</li>
          <li>Dati raccolti: dati di utilizzo, indirizzo IP, log tecnici</li>
          <li>Luogo del trattamento: Stati Uniti, Unione Europea</li>
          <li>
            Privacy Policy:{" "}
            <a
              href="https://vercel.com/legal/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              vercel.com/legal/privacy-policy
            </a>
          </li>
          <li>
            Base giuridica: legittimo interesse del Titolare (Art. 6, par. 1,
            lett. f GDPR)
          </li>
        </ul>

        <h2>8. Diritti dell'Utente</h2>
        <p>
          In conformità al Regolamento UE 2016/679 (GDPR), in qualsiasi momento
          l'utente ha il diritto di:
        </p>
        <ul>
          <li>Accedere ai propri dati personali (Art. 15 GDPR)</li>
          <li>Rettificare i dati inesatti o incompleti (Art. 16 GDPR)</li>
          <li>Cancellare i propri dati - diritto all'oblio (Art. 17 GDPR)</li>
          <li>Limitare il trattamento dei propri dati (Art. 18 GDPR)</li>
          <li>Opporsi al trattamento dei propri dati (Art. 21 GDPR)</li>
          <li>Portabilità dei dati (Art. 20 GDPR)</li>
          <li>Revocare il consenso in qualsiasi momento (Art. 7 GDPR)</li>
          <li>
            Proporre reclamo al Garante per la Protezione dei Dati Personali (
            <a
              href="https://www.garanteprivacy.it"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.garanteprivacy.it
            </a>
            )
          </li>
        </ul>
        <p>
          Per esercitare i propri diritti, l'utente può contattare il Titolare
          all'indirizzo:{" "}
          <a href="mailto:info@esteticaelite.eu">info@esteticaelite.eu</a>
        </p>

        <h2>9. Modifiche alla Privacy Policy</h2>
        <p>
          Il Titolare si riserva il diritto di apportare modifiche alla
          presente Privacy Policy in qualsiasi momento, dandone comunicazione
          agli utenti tramite pubblicazione sul Sito.
        </p>
      </div>
    </article>
  );
}
